import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { TerceroRiesgoService } from '../../_services/tercero-riesgo.service';
import { TerceroRiesgo } from '../../_models/tercero-riesgo';
import { BusquedaFiltros } from '../../_models/busqueda-filtros';
import { Table } from 'primeng/table';


@Component( {
  selector: 'app-cambio-perfil',
  templateUrl: 'cambio-perfil.component.html'
} )
export class CambioPerfilComponent implements OnInit {

  // Config
  model: TerceroRiesgo = null;


  // Tabla
  columnas: any[] = [];
  datosTabla: any[] = [];
  cargandoTabla = false;

  // Input y output
  busqueda: string = '';

  @ViewChild('td', { static: true }) tabla: Table;

  //Paginacion
  loadingPerfilesRiesgo = true;
  page = '0';
  rowsPerPage: number = 0;
  rowsCount: number = 0;


  constructor(
    private router: Router,
    private navService: NavService,
    private terceroRiesgoService: TerceroRiesgoService,
  ) {
  }

  ngOnInit() {

    this.columnas = [
      { field: 'numeroDocumento', header: this.navService.buscarMensaje( 'TERCERO.LBL_NUMERODOCUMENTO' ), sort: true },
      { field: 'primerNombre', header: this.navService.buscarMensaje( 'TERCERO.LBL_NOMBRES' ), sort: true },
      { field: 'primerApellido', header: this.navService.buscarMensaje( 'TERCERO.LBL_APELLIDOS' ), sort: true },
      { field: 'nombrePerfilesRiesgos', header: this.navService.buscarMensaje( 'PERFILRIESGO.LBL_PERFILRIESGO' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    //this.refrescarTabla();
  }

  private editar( row: TerceroRiesgo ) {
    // Editar o agregar
    if ( row != null ) {
      this.router.navigate( [ 'apl/cambio-perfil/actualizar/' + row.idTercero ] ).then();
    }
  }

  refrescarTabla() {
    this.cargandoTabla = true;
    this.terceroRiesgoService.buscadorPerfilSolicitud()
      .subscribe( x => {
        this.datosTabla = x;
        this.cargandoTabla = false;
      } );
  }

  setSearch() {
    this.navService.setSearch( 'cambio-perfil.component', this.busqueda );
  }

  filterEnter() {
    if ( !this.cargandoTabla ) {
      this.filter();
    }
  }

  filter( event?: any ) {
    this.cargandoTabla = true;
    this.rowsCount = 10
    this.rowsPerPage = 10;
    if ( event ) {
      this.page = String( event.first / this.rowsPerPage );
    } else {
      this.page = '0';
      this.tabla.first = 0;
    }

    const a = new BusquedaFiltros();
    a.pagina = Number( this.page );
    a.cantidad = this.rowsPerPage;
    a.query = '';
    if ( this.busqueda && this.busqueda.trim().length > 2 ) {
      a.query = this.busqueda.trim();
    }

    if ( a.query.length > 0 ) {
      this.terceroRiesgoService.buscarEnPerfilesRiesgo( a ).subscribe( rta => {
        this.rowsCount = Number( rta.total );
        this.datosTabla = rta.data;
        this.cargandoTabla = false;
      } );
    } else {
      this.rowsCount = 0;
      this.datosTabla = [];
      this.cargandoTabla = false;
    }
  }

}
